// Task 4a — commercial party master (spec §2, 7.4; plan Task 1/4a). Field names mirror
// backend com.kervolt.oms.commercial.dataclass.{CommercialPartyDTO,CreateCommercialPartyRequest,
// UpdateCommercialPartyRequest} and com.kervolt.oms.enums.CommercialPartyType verbatim (R-15).
// Reuses LC_VIEW/LC_MANAGE -- no dedicated permission catalog entry (CommercialPartyController's
// Javadoc).

export type CommercialPartyType =
    | 'BANK'
    | 'FREIGHT_FORWARDER'
    | 'SHIPPING_LINE'
    | 'CUSTOMS_AGENT'
    | 'TESTING_LAB'
    | 'AUDITOR'
    | 'SUBCONTRACTOR'
    | 'INSURER'
    | 'BUYING_AGENT'
    | 'OTHER';

export const COMMERCIAL_PARTY_TYPES: CommercialPartyType[] = [
    'BANK', 'FREIGHT_FORWARDER', 'SHIPPING_LINE', 'CUSTOMS_AGENT',
    'TESTING_LAB', 'AUDITOR', 'SUBCONTRACTOR', 'INSURER', 'BUYING_AGENT', 'OTHER',
];

/** Friendly display label overrides -- falls back to the raw `CommercialPartyType` text for any
 * type not listed here. Fix round 1 (concern 1): wired into both `CommercialPartyList`'s type
 * filter/table and `CommercialPartyFormDialog`'s type select via a local `partyTypeLabel` helper
 * in each file. */
export const COMMERCIAL_PARTY_TYPE_LABELS: Partial<Record<CommercialPartyType, string>> = {
    BUYING_AGENT: 'Buying agent / buying house',
};

/** Backend CommercialPartyDTO. */
export interface ICommercialParty {
    id: string;
    institutionId: string;
    partyType: CommercialPartyType;
    code: string;
    name: string;
    contactPerson: string | null;
    email: string | null;
    phone: string | null;
    address: string | null;
    countryCode: string | null;
    swiftCode: string | null;
    branch: string | null;
    licenseNo: string | null;
    remarks: string | null;
    active: boolean;
}

/** {@code code} is unique per institution (live rows only), case-insensitive -- §2, 7.4. Same
 * field set as backend Create/UpdateCommercialPartyRequest (no lifecycle field here -- activate/
 * deactivate are separate endpoints). */
export interface ICreateCommercialPartyRequest {
    partyType: CommercialPartyType;
    code: string;
    name: string;
    contactPerson?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: string | null;
    countryCode?: string | null;
    swiftCode?: string | null;
    branch?: string | null;
    licenseNo?: string | null;
    remarks?: string | null;
}

export type IUpdateCommercialPartyRequest = ICreateCommercialPartyRequest;
